import ChartLegend from "./ChartLegend";

export default ChartLegend